import { useMemo, useState } from "react";

const n = (s) => (s || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
export const skillMatches = (s, q) => !q || [s.name, s.code, ...(s.synonyms || [])].some((x) => n(x).includes(n(q)));

/** Selettore competenza ricercabile (nome, codice, sinonimi). */
export default function SkillPicker({ skills, value, onChange, testid, placeholder = "Cerca competenza…" }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const sel = skills.find((s) => s.id === value);
  const area = useMemo(() => Object.fromEntries(skills.filter((s) => s.level === "area").map((s) => [s.code, s.name])), [skills]);
  const list = skills.filter((s) => s.active !== false && skillMatches(s, q)).slice(0, 40);
  return (
    <div className="relative">
      <input data-testid={testid} aria-label="Competenza" className="w-full h-10 border border-zinc-300 rounded-md px-2 text-sm" placeholder={placeholder}
        value={open ? q : sel ? `${sel.code} · ${sel.name}` : ""} onFocus={() => { setOpen(true); setQ(""); }} onBlur={() => setTimeout(() => setOpen(false), 150)} onChange={(e) => setQ(e.target.value)} />
      {open && (
        <div className="absolute z-30 mt-1 w-full max-h-64 overflow-y-auto bg-white border border-zinc-200 rounded-md shadow-lg" role="listbox">
          {list.length === 0 && <div className="px-3 py-2 text-xs text-zinc-500">Nessuna competenza trovata</div>}
          {list.map((s) => (
            <button type="button" key={s.id} role="option" aria-selected={s.id === value} data-testid={`${testid}-opt-${s.code}`} onMouseDown={() => { onChange(s.id); setOpen(false); }}
              className={`w-full text-left px-3 py-1.5 text-sm hover:bg-zinc-50 ${s.level === "area" ? "font-semibold" : "pl-6"}`}>
              <span className="font-mono text-[10px] text-zinc-400 mr-2">{s.code}</span>{s.name}{s.level !== "area" && <span className="text-[10px] text-zinc-400 ml-1">· {area[s.area]}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
